/* 10th Inning — Base JS */

// Cart add with fetch API
document.addEventListener('DOMContentLoaded', function () {

  // Add to cart buttons on collection/homepage
  document.querySelectorAll('.product-btn[type="submit"], .add-to-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var form = btn.closest('form');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id.value, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Update cart count in nav
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var cartLinks = document.querySelectorAll('.cart-link');
            cartLinks.forEach(function (el) {
              el.textContent = 'Cart (' + cart.item_count + ')';
            });
          });
        // Brief button feedback
        var orig = btn.textContent;
        btn.textContent = 'Added!';
        btn.style.background = '#C8922A';
        btn.style.color = '#1A1008';
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
          btn.style.color = '';
        }, 1600);
      })
      .catch(function (err) { console.error('Cart error:', err); });
    });
  });

  // Thumbnail image switcher on product page
  document.querySelectorAll('[onclick]').forEach(function(el) {
    // onclick already set inline — just ensure no double-fire
  });

  // Mobile nav toggle (basic)
  var mobileToggle = document.getElementById('mobile-nav-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.style.display === 'block';
      mobileNav.style.display = open ? 'none' : 'block';
    });
  }

});
